<div class="modal-top-bar">
    <h3>{{ !!user.id ? "#" + user.id + " " + user.name + ' ' + user.surname : 'Create new user' }}</h3>
</div>
<div class="modal-content mb-4">
    <div class="user-dialog-content">
        <div class="name">
            Username
            <input type="text" [(ngModel)]="user.userName"/>
        </div>
        <div class="name">
            Name
            <input type="text" [(ngModel)]="user.name"/>
        </div>
        <div class="name">
            Surname
            <input type="text" [(ngModel)]="user.surname"/>
        </div>
        <div class="name">
            Password
            <input type="password" [(ngModel)]="user.password"/>
        </div>
        <div class="name">
            Repeat password
            <input type="password" [(ngModel)]="user.password2"/>
        </div>
        <div class="admin">
            Administrator privileges
            <mat-checkbox [(ngModel)]="user.admin"></mat-checkbox>
        </div>
    </div>
</div>
<div class="modal-bottom-bar">
    <button *ngIf="!!user.id" [disabled]="user.blockedDelete" class="button outline danger" (click)="deleteUser()">Delete user</button>
    <div *ngIf="!!user.id && user.blockedDelete" class="dialog-info-block">
        <mat-icon class="icon-info">info</mat-icon>
        <div>
            <span class="block">User has managed alerts.</span>
            <span class="block">Delete not allowed</span>
        </div>
    </div>
    <div class="flex-grow-1"></div>
    <button class="button outline" (click)="dialogRef.close(false)">Cancel</button>
    <button [disabled]="!validUserData() || working" *ngIf="!!user.id" class="button" (click)="updateUser()">Update</button>
    <button [disabled]="!validUserData() || working" *ngIf="!user.id" class="button" (click)="createUser()">Create</button>
    
</div>